import { alpha, styled, TablePagination } from "@mui/material";
import React from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import NoDataImg from "./NoDataImage";

const DataGridTable = ({
  rows,
  columns,
  height,
  handleChangePage,
  page,
  totalcount,
  rowsPerPage,
  handleChangeRowsPerPage,
  isLoading,
  rowheight,
  pagination = true,
}) => {
  const StripedDataGrid = styled(DataGrid)(() => ({
    [`& .${gridClasses.row}.Mui-odd`]: {
      backgroundColor: "#4d4d4d15", // light shade of #BFA98E
      "&:hover": {
        backgroundColor: alpha("#4D4D4D", 0.15),
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },

    [`& .${gridClasses.row}.Mui-even`]: {
      backgroundColor: "#FFF",
      "&:hover": {
        backgroundColor: alpha("#4D4D4D", 0.15),
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }));
  return (
    <>
      <StripedDataGrid
        className="myDataGridContainer"
        rows={rows}
        rowHeight={rowheight && rowheight}
        columns={columns}
        disableSelectionOnClick
        disableColumnFilter
        getRowId={(e) => (e?.rowid ? e?.rowid : e?.id)}
        disableColumnMenu
        disableColumnReorder
        slotProps={{
          loadingOverlay: {
            variant: "skeleton",
            noRowsVariant: "skeleton",
            style: { backgroundColor: '#4D4D4D30' } 
          },
        }}
        disableMultipleColumnsSorting
        disableColumnSelector
        hideFooterPagination
        hideFooter
        slots={{ noRowsOverlay: NoDataImg }}
        loading={isLoading}
        pagination={false}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "Mui-even" : "Mui-odd"
        }
        sx={{
          borderRadius: "10px",
          borderWidth: "1.5px",

          borderStyle: "solid",

          borderColor: "#4D4D4D50",

          height: height,
          ".MuiDataGrid-columnHeaderTitle": {
            color: "#4D4D4D",
            fontWeight: 600,
          },
          ".MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          ".MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-cell": {
            textAlign: "center",
            color: "#000",
            borderWidth: "1px 1px 0px 0px",
            borderStyle: "solid",
            borderColor: "#4D4D4D50",
            "&:focus": { outline: "none" },
          },

          ".MuiDataGrid-topContainer .MuiDataGrid-columnHeaders": {
            // backgroundColor: "rgba(191, 169, 142, 0.15) !important",
            backgroundColor: "white !important",
            color: "#4D4D4D !important",
          },
          ".MuiDataGrid-container--top [role=row]": {
            backgroundColor: "white !important",

          },
        }}
      />
      {pagination && (
        <TablePagination
          sx={{ color: "#000" }}
          component="div"
          count={totalcount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default DataGridTable;
